// A confirm dialog is blocking and MUST paint above any open menu/popover.
// Bootstrap's default scale puts popover (1070) and tooltip (1080) ABOVE the
// modal (1055), so the table-config popover would otherwise cover this dialog.
// Raise the confirm modal + its backdrop above that menu layer. The app's real
// tooltips (TooltipPopOver) live at 1100 and intentionally stay on top.
.confirmModalRaised {
  z-index: 1085 !important;
}

.confirmBackdropRaised {
  z-index: 1082 !important;
}

.iconContainer {
  text-align: center;
  margin-bottom: 0.75rem;
  font-size: 2.5rem;
  line-height: 1;
}

.iconWarning {
  color: var(--bs-warning);
}

.iconError {
  color: var(--bs-danger);
}

.iconSuccess {
  color: var(--bs-success);
}

.iconInfo {
  color: var(--bs-info);
}

.title {
  text-align: center;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.textContent {
  text-align: center;
  white-space: pre-line;
  color: var(--bs-secondary-color);
}

.footer {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}
